import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const TaxRateAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.taxRateAccess
        ? setValues((j) => ({
            ...j,
            taxRate: {
              create: true,
              edit: true,
              delete: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            taxRate: {
              create: false,
              edit: false,
              delete: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.taxRateAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      taxRate: { ...j.taxRate, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.taxRateAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.taxRate?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.taxRate?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.taxRate?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default TaxRateAccess;
